<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col sm="12" md="10">
        <v-layout class="row justify-center align-start printNone">
          <v-flex xs12>
            <div class="title pa-3 primary--text font-weight-bold">{{ $t('trading_license_application') | uppercase }}</div>
          </v-flex>
          <br /><br />
          <v-layout class="align-center reverse row wrap printNone pl-5 pr-5">
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" @click="print(data, 1)">{{ $t('page_license.print') }}</v-btn>
          </v-layout>
        </v-layout>
        <v-layout class="row justify-center align-start printNone pa-5" style="">
          <v-flex xs12 style="background-color: dodgerblue" class="pa-2">
            <div class="pa-1 pt-2 pb-2 white--text body2">{{ $t('trading_license_message') | uppercase }}</div>
            <div class="pa-1 white--text body2">{{ $t('trading_license_message2') | uppercase }}</div>
            <div class="pa-1 white--text body2">{{ $t('trading_license_message3') | uppercase }}</div>
          </v-flex>
        </v-layout>
        <trading-required-documents />
        <additional-docs />
        <br />
        <v-layout justify-center align-start v-if="Object.keys(data).length === 0" class="printNone">
          <v-flex xl2 md4 sm6 xs12>
            <v-card class="br-10 pa-4 text-xs-center">
                <div class="title pa-3">{{ $t('no_account_selected') }}</div>
                <v-layout row wrap pt-2 justify-center>
                  <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" round type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
                </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-list two-line dense>
              <v-subheader class="printNone"><h3>{{ $t('application_information') }}</h3></v-subheader>
              <v-divider class="printNone"/>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data._id }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('reference_no') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.timestamp | date }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('application_date') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase font-weight-bold">{{ $t(data.status) | uppercase }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ (data.status_update_date || data.timestamp) | date }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('last_status_update') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-flex xs12 sm11 md6 class="property_info">
              <v-list two-line dense>
                <v-subheader class="printNone"><h3>{{ $t('applicant_information') }}</h3></v-subheader>
                <v-divider class="printNone"/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.name }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('name', { field: $t("applicant") }) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(data.applicant.identity_type) }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('identity_type', { field: $t("applicant") }) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.identity_no }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('identity_no', { field: $t("applicant") }) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.phone }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('phone', { field: $t("applicant") }) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 font-weight-bold">{{ data.applicant.email }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('email', { field: $t("applicant") }) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.address }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('address', { field: $t("applicant") }) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <br />
              <v-list two-line class="d-print-flex">
                <v-subheader class="printNone pb-2" style="background-color: white;"><h3>{{ $t('business_information') }}</h3></v-subheader>
                <v-divider class="printNone" style=" margin-top: -5px"/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.business_name }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('business_name') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.address }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('business_address') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.phone }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('business_phone') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.fax }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('business_fax') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.business_location }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('business_location') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.state }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('business_state') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(`premise_${data.business.premise}`) }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('premise') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div v-if="!!data.business.premise">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.bumiputera_share }} %</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('bumiputera_share') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.title_no }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('title_no') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.no_of_trading_on_property }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('no_of_trading_on_property') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.use_code }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('use_code') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.installment }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('installment') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item> -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.area }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('area') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.business.payment_needed | currency('RM ') }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('payment_needed') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>
              <br />
              <v-list two-line>
                <v-subheader class="printNone pb-2" style="background-color: white;"><h3>{{ $t('business_activity') }}</h3></v-subheader>
                <v-divider class="printNone" style=" margin-top: -5px"/>
                <v-list-item class="text-xs-center" v-if="data.business.business_activity.length < 1">
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t('no_council_license_needed') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <div v-for="(activity, index) in data.business.business_activity" :key="index" class="pt-2">
                  <v-list-item-content class="pa-1 pl-3">
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ activity.code }} - {{ activity.name }}</v-list-item-title>
                  </v-list-item-content>
                </div>
              </v-list>
              <br />
              <v-list two-line>
                <!-- <v-subheader class="printNone pb-2" style="background-color: white;"><h3>{{ $t('council_license_information') }}</h3></v-subheader>
                <v-divider class="printNone" style=" margin-top: -5px"/>
                <v-list-item class="text-xs-center" v-if="data.council_license.length < 1">
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t('no_council_license_needed') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item> -->
                <div v-for="(item, index) in data.council_license" :key="index">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ item.charge_per_unit | currency('RM ') }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('charge_per_unit') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ item.license_charge | currency('RM ') }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('license_charge') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ item.other_charges | currency('RM ') }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('other_charges') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ item.units }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('units') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list>
            </v-flex>
          <v-flex xs12 sm11 md6 class="pl-2 pr-2">
            <v-layout column>
              <v-list two-line dense>
                <v-subheader class="printNone"><h3>{{ $t('owner_information') }}</h3></v-subheader>
                <v-divider class="printNone"/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(ownership_type(data.ownership_type)) }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('ownership_type') }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <div v-for="(owner, i) in data.owners" :key="i">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(ownerTypes(owner.type)) }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('type') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.name }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('name', { field: $t(ownerTypes(owner.type)) }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(owner.identity_type) }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('identity_type', { field: $t(ownerTypes(owner.type)) }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.identity_no }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('identity_no', { field: $t(ownerTypes(owner.type)) }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.date_of_birth }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('date_of_birth') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.work_pass }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('work_pass') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.expired_date_of_pass }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('expired_date_of_pass') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.nationality }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('nationality') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ citizenship(owner.citizenship) }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('citizenship') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(`label_gender.${owner.gender}`) }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('gender') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ religion(owner.religion) }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('religion') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.race }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('race') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ bumiputera_status(owner.bumiputera_status) }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('bumiputera_status') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.residential_address }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('residential_address') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.mailing_address }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('mailing_address') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.state }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('state') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.mobile_tel }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('mobile_tel') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.office_tel }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('office_tel') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ owner.residential_tel }}</v-list-item-title>
                      <v-list-item-subtitle class="body-2">{{ $t('residential_tel') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="i !== data.owners.length - 1" class="printNone" />
                </div>
              </v-list>
              <br class="printNone">
                <v-list two-line dense v-if="data.ownership_type && data.ownership_type !== 'sole_proprietor' && data.ownership_type !== 'partnership' && data.ownership_type !== '1' && data.ownership_type !== '2'">
                  <v-subheader class="printNone" style="background-color: white;"><h3>{{ $t('company_information') }}</h3></v-subheader>
                  <v-divider class="printNone"/>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.name }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('name', { field: $t("company_organization") }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.register_no }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('register_no') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ company_type(data.company_organization.company_type) }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('company_type') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.organization_cooperation_field }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('organization_cooperation_field') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.office_address }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('office_address') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.mailing_address }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('mailing_address') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.phone }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('phone', { field: $t("company_organization") }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.company_organization.fax }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('fax', { field: $t("company_organization") }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 font-weight-bold">{{ data.company_organization.email }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('email', { field: $t("company_organization") }) }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                    <v-list-item-title class="body-2 font-weight-bold">{{ data.company_organization.homepage }}</v-list-item-title>
                    <v-list-item-subtitle class="body-2">{{ $t('homepage') }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-layout>
            </v-flex>
            <v-subheader class="printNone" style="background-color: white;"><h3>{{ $t('supporting_documents') }}</h3></v-subheader>
              <v-divider class="printNone"/>
                <v-row v-if="data._attachments">
                    <v-col sm="10" md="8" lg="4" xl="4" v-for="(doc, i) in data._attachments" :key="i" class="mt-5">
                      <pdf :src="doc.dataurl" :page="pageNum" @num-pages="numPages = $event" style="border: 2px solid black"></pdf>
                      <div class="text-center"><p style="font-weight: bold;">{{ doc.name.replaceAll('_', ' ').toUpperCase() }}</p></div>
                      <div class="text-center">
                        <button @click="onPagePrev">Prev</button>
                        <button @click="onPageNext">Next</button>
                        <span>{{ pageNum }} / {{ numPages }}</span>
                      </div>
                    </v-col>
                </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import AdditionalDocs from './additional_document'
import TradingRequiredDocuments from './trading_required_documents'
import QrcodeVue from 'qrcode.vue'
import pdf from 'vue-pdf'

export default {
  beforeMount () {
    this.fetchData({ id: this.$route.params.id })
  },
  components: {
    AdditionalDocs,
    TradingRequiredDocuments,
    QrcodeVue,
    pdf
  },
  computed: {
    ...vuex.mapState({
      data: state => state.tradingForm.data,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      url: 'http://services.mptpay.net/' + window.location.hash,
      pageNum: 1,
      numPages: null
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'tradingForm/fetchData'
    }),
    onPagePrev () {
      if (this.pageNum > 1) {
        this.pageNum--
      }
    },
    onPageNext () {
      if (this.pageNum < this.numPages) {
        this.pageNum++
      }
    },
    company_type (value) {
      let list = [
        { value: 'The Registrar of Cos', type: 'company', epbt2: '1' },
        { value: 'Wholly Owned By', type: 'company', epbt2: '2' }
        // { value: 'Organization', type: 'organization_or_cooperation', epbt2: "3" },
        // { value: 'Coorperation', type: 'organization_or_cooperation', epbt2: "3" }
      ]
      return list.find(v => v.epbt2 === value) ? list.find(v => v.epbt2 === value).value : '-'
    },
    ownerTypes (value) {
      const type = this.data.ownership_type
      let list = [
        { value: 'director', epbt2: '1' },
        { value: 'manager', epbt2: '2' },
        { value: 'company_secretary', epbt2: '3' },
        { value: 'secretary', epbt2: '4' }
      ]
      if (type === '1' || type === '2' || type === 'sole_proprietor' || type === 'partnership') {
        list = [
          { value: 'owner', epbt2: '1' },
          { value: 'partnerships', epbt2: '2' },
          { value: 'manager', epbt2: '3' }
        ]
      }
      return list.find(v => v.epbt2 === value) ? list.find(v => v.epbt2 === value).value : '-'
    },
    citizenship (value) {
      const list = [
        { value: 'MALAYSIAN - SABAH', epbt2: '1' },
        { value: 'MALAYSIAN - SARAWAK / SEMENANJUNG MALAYSIA', epbt2: '2' },
        { value: 'PEMASTAUTIN / PEMEGANG PERMIT TINGGAL TETAP', epbt2: '3' },
        { value: 'OTHERS', epbt2: '3' }
      ]
      return list.find(v => v.epbt2 === value) ? list.find(v => v.epbt2 === value).value : '-'
    },
    ownership_type (value) {
      const list = [
        { value: 'sole_proprietor', epbt2: '1' },
        { value: 'partnership', epbt2: '2' },
        { value: 'private_limited_company', epbt2: '3' },
        { value: 'public_limited_company', epbt2: '4' },
        { value: 'corporation_company', epbt2: '5' },
        { value: 'organization_or_cooperation', epbt2: '6' },
        { value: 'government', epbt2: '9' }
      ]
      return list.find(v => v.epbt2 === value) ? list.find(v => v.epbt2 === value).value : '-'
    },
    bumiputera_status (value) {
      const list = [{ value: 'Bumiputera', epbt2: '1' }, { value: 'Non-Bumiputera', epbt2: '2' }]
      return list.find(v => v.epbt2 === value) ? list.find(v => v.epbt2 === value).value : '-'
    },
    religion (value) {
      const list = [
        { value: 'ISLAM', epbt2: '1' },
        { value: 'CHRISTIAN', epbt2: '2' },
        { value: 'BUDDHIST', epbt2: '3' },
        { value: 'OTHERS', epbt2: '4' }
      ]
      return list.find(v => v.epbt2 === value) ? list.find(v => v.epbt2 === value).value : '-'
    },
    hideIC: function (text) {
      var t = text
      var hiddenText = ''
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          if (i < t.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += t[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      var t = text
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    print: async function (data, type) {
      this.loading = true
      function pad (n) { return n < 10 ? '0' + n : n }
      // const logo = await this.$store.dispatch('metadata/fetchLogoBase64', { council: 'mpt' })
      const ref = this.data._id
      const params = {
        date: pad(new Date(this.data.timestamp).getDate()) + '/' + pad(new Date(this.data.timestamp).getMonth() + 1) + '/' + new Date(this.data.timestamp).getFullYear(),
        // logo: logo,
        record: data,
        route: `https://services.mptpay.net/#/trading/preview/${ref}`,
        title: 'PERMOHONAN LESEN PERNIAGAAN'
      }
      const fileName = 'PERMOHONANLESENPERNIAGAAN_' + ref + '.pdf'
      let printWorker = new Worker('print/receipt/trading_license.js')
      printWorker.onmessage = function (response) {
        if (!window.hasOwnProperty('cordova')) {
          const anchor = document.createElement('a')
          anchor.href = URL.createObjectURL(response.data)
          anchor.download = fileName
          document.body.appendChild(anchor)
          anchor.click()
          anchor.remove()
          return
        }
        const errorCallback = function (e) {
          console.error(e)
        }
        const storageLocation = cordova.file.externalApplicationStorageDirectory
        window.resolveLocalFileSystemURL(storageLocation,
          function (directory) {
            directory.getFile(fileName, {
              create: true,
              exclusive: false
            },
            function (fileEntry) {
              fileEntry.createWriter(function (writer) {
                writer.onwriteend = function () {
                  cordova.plugins.fileOpener2.open(
                    storageLocation + fileName,
                    'application/pdf',
                    {
                      error: function (e) {
                        console.error('Error status: ' + e.status + ' - Error message: ' + e.message)
                      },
                      success: function () {
                        console.info('file opened successfully')
                      }
                    }
                  )
                }
                writer.seek(0)
                writer.write(response.data)
              }, errorCallback)
            }, errorCallback)
          }, errorCallback)
      }
      await printWorker.postMessage(params)
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

.text-uppercase {
  text-transform: 'uppercase';
  font-weight: 'bold';
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  nav {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -110px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25% !important;
  }
  .width33 {
    width: 33% !important;
  }
  .width50 {
    width: 50% !important;
  }
  /* .marginBottom40 {
    margin-bottom: -40px;
  } */
}
</style>
